<template>
	<div class="blank-component" v-if="data.type=='blank'">
		<p class="blank-title">
			<span>{{data.id}}.</span>
			{{data.text}} ({{data.score}}分)
		</p>
		<input class="blank-input" type="text"
			   :class="{error: error(), isAnswer: isAnswer()}"
			   v-model="value" @input="change" :disabled="disabled" maxlength="100"/>
		<div class="answers" v-if="showAnswers && data.answers">
			<div v-for="ans in data.answers" :class="{correct: compare(value, ans)}">{{ans}}</div>
		</div>
	</div>
</template>

<script>
    // 引入mixins
    import mixins_config from "@/mixins/config.js";

    export default {
        name: "BlankComponent",
        mixins: [mixins_config],
        props: {
            data: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                value: null
            };
        },
        created() {
            let that = this;
            if (that.app.submits.hasOwnProperty(that.data.key) && that.app.submits[that.data.key]) {
                that.value = that.app.submits[that.data.key]
            }
        },
		watch:{
            submits(n) {
                this.value = n[this.data.key]
			}
		},
        methods: {
            change() {
                let that = this;
                if (that.disabled) {
                    return
                }
                // 多空格变成一个空格，去掉左右两边空格
				if (that.value) {
                    that.value = that.value.replace(/([\s]{2,})/, ' ')
				}
                that.app.submits[that.data.key] = that.value
            },

            // 当前选项(任意选项)是否是正确选项
            correct() {
                if (this.data.answers && this.data.answers.length > 0 && this.submits && this.submits[this.data.key]) {
                    for(let i = 0, len = this.data.answers.length; i < len; i++) {
                        if (this.data.answers[i].replace(/([\s]{2,})/, ' ').replace(/([’])/, '\'').trim() === this.submits[this.data.key].replace(/([\s]{2,})/, ' ').replace(/([’])/, '\'').trim()) {
                            return true;
						}
					}
				}
                return false;
            },
			
			compare(v1, v2) {
                if (v1 === v2) {
                    return true;
				}
                if (!v1 || !v2) {
                    return false;
				}
                return v1.replace(/([\s]{2,})/, ' ').trim() === v2.replace(/([\s]{2,})/, ' ').trim();
			},

            // 是否错误
            error() {
                if (!this.showErrors) {
                    return false
                }
                return !this.correct()
            },
            // 是否是题目的答案
            isAnswer() {
                if (!this.showAnswers && !this.showErrors) {
                    return false;
                }
                return this.correct()
            },
        },
    };
</script>

<style lang="scss" scoped>
	.blank-input.isAnswer {
		color: #33cc33;
		border-color: #33cc33;
	}
	
	.blank-input.error {
		color: red;
		border-color:red;
	}
	
	.answers {
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		
		div {
			border: 1px solid #1890ff;
			color: #1890ff;
			padding: 0 8px;
			border-radius: 5px;
			margin-right: 1rem;
		}
		.correct {
			color: #33cc33;
			border-color: #33cc33;
		}
	}
</style>
